import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import api from "../../../services/api";
import dayjs from "dayjs";

export async function attendanceRecord(filtro: any, club: any) {
    const response = await api.post(`/api/app/presence/report`, { filtro })
    const athletes: any[] = response.data

    const workbook = new ExcelJS.Workbook();
    const ws = workbook.addWorksheet("carga_frequencia");

    ws.columns = [
        { header: "ORD NUMÉRICA", key: "ordem", width: 15 },
        { header: "CR_ENTIDADE", key: "crEntidade", width: 20 },
        { header: "CNPJ", key: "cnpj", width: 25 },
        { header: "NOME_CLUBE", key: "nomeClube", width: 45 },
        { header: "CPF_ATIRADOR", key: "cpf", width: 20 },
        { header: "CR_CAC", key: "crCac", width: 20 },
        { header: "NOME_ATIRADOR", key: "nomeAtirador", width: 40 },
        { header: "DATA_QUE_FREQUENTOU", key: "data", width: 30 },
    ];

    const header = ws.getRow(1);

    function limparTexto(valor:string):string {
        return valor.replace(/[.,/-]/g, '');
    }

    header.eachCell((cell) => {
        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFF00" },
        };

        cell.font = {
            bold: false,
            color: { argb: "000000" },
        };

        cell.alignment = {
            horizontal: "center",
            vertical: "middle",
        };

        cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
        };
    });

    const dadosClube =
        {
            cr_number: limparTexto(club?.cr_number),
            cnpj: limparTexto(club?.cnpj),
            nomeClube: club?.fantasia,
        }

    ws.addRows(
        athletes.map((item: any, index: number) => ({
            ordem: index + 1,
            crEntidade: dadosClube.cr_number,
            cnpj: dadosClube.cnpj,
            nomeClube: dadosClube.nomeClube,
            cpf: limparTexto(item?.athlete?.cpf),
            crCac: limparTexto(item?.athlete?.cr_number),
            nomeAtirador: item?.athlete?.full_name,
            data: item?.capture_timestamp ? new Date(item.capture_timestamp) : null,
        }))
    );

    ws.getColumn("data").numFmt = "dd/mm/yyyy";

    ws.eachRow((row) => {
        row.eachCell((cell) => {
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };
        });
    });

    const buffer = await workbook.xlsx.writeBuffer();

    const periodText =
        filtro?.period?.startDate && filtro?.period?.endDate
            ? `_(${dayjs(filtro.period.startDate).format('DD/MM/YYYY')} - ${dayjs(filtro.period.endDate).format('DD/MM/YYYY')})`
            : '';

    saveAs(new Blob([buffer]), `relatorio_carga_frequencia${periodText}.xlsx`);
}